export default __webpack_public_path__ + "static/media/outro-img-yeti-1.6f1b940e.png";